import { createFileRoute } from '@tanstack/react-router'

import { FeatureFlagsPage } from '@/pages/feature-flags/FeatureFlags.page'

export const Route = createFileRoute('/_auth/feature-flags')({
  component: FeatureFlagsPage,
})
